import { styled } from "@mui/material/styles";
import { Box, Stack } from "@mui/material";

export const MileageCorrectionCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: "12px",
  paddingY: "24px",
  marginBottom: "24px"
}));

export const MileageCorrectionHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  paddingBottom: "12px",
  marginBottom: "20px",
  borderBottom: `1px solid ${theme.palette.divider}`
}));

export const MileageCorrectionContent = styled(Stack)(({ theme }) => ({
  gap: "16px",
  paddingBottom: "12px",
  borderBottom: `1px solid ${theme.palette.divider}`
}));

export const MileageCorrectionItem = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "12px 0"
}));

export const MileageCorrectionLabel = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  color: theme.palette.text.secondary,
  fontSize: "14px",
  fontWeight: 500,
  minWidth: "200px"
}));

export const MileageCorrectionValue = styled(Box)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: "14px",
  fontWeight: 600,
  textAlign: "right",
  flex: 1,
  display: "flex",
  alignItems: "center",
  gap: "6px"
}));
